(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["freedom-fund-round"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const VOTING_API = 'https://voting.freedomfuel.us';
    let cachedTotal = null;

    function formatVotes(n) {
      if (n >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
      if (n >= 1e3) return Math.round(n / 1000) + 'K';
      return String(Math.round(n));
    }

    async function fetchTotalVotes() {
      if (cachedTotal !== null) return cachedTotal;
      try {
        const res  = await fetch(VOTING_API + '/api/storefront/heroes', { mode: 'cors' });
        const json = await res.json();
        const heroes = json.heroes || [];
        cachedTotal = heroes.reduce(function (sum, h) { return sum + (Number(h.votesCast) || 0); }, 0);
      } catch (e) {
        cachedTotal = 0;
      }
      return cachedTotal;
    }

    function updateSection(root, total) {
      var goal = parseInt(root.dataset.ffrGoal || '500000', 10);
      var pct  = goal > 0 ? Math.min(100, (total / goal) * 100) : 0;

      var countEl = root.querySelector('[data-ffr-votes-count]');
      if (countEl) countEl.textContent = formatVotes(total);

      var fillEl = root.querySelector('[data-ffr-progress-fill]');
      if (fillEl) {
        var minFill = parseFloat(fillEl.dataset.ffrMinFill || '0') || 0;
        fillEl.style.width = Math.max(pct, minFill).toFixed(2) + '%';
      }

      var trackEl = root.querySelector('[data-ffr-progress-track]');
      if (trackEl) trackEl.setAttribute('aria-valuenow', total);
    }

    function init() {
      var sections = document.querySelectorAll('[data-ffr]');
      if (!sections.length) return;

      // Sections with a manual override skip the live API.
      var liveSections = [];
      sections.forEach(function (root) {
        var override = parseInt(root.dataset.ffrVotesOverride || '0', 10);
        if (override > 0) {
          updateSection(root, override);
        } else {
          liveSections.push(root);
        }
      });

      if (liveSections.length) {
        fetchTotalVotes().then(function (total) {
          liveSections.forEach(function (root) { updateSection(root, total); });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-nominees"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var sliders = document.querySelectorAll('[data-nominee-slider]');
      sliders.forEach(function (slider) {
        if (slider._nomineeInit) return;
        slider._nomineeInit = true;
        var slides = slider.querySelectorAll('.hero-nominees__slide');
        if (slides.length < 2) return;

        var current = 0;

        slider.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-nominee-next]');
          if (!btn) return;
          e.preventDefault();
          slides[current].classList.remove('hero-nominees__slide--active');
          current = (current + 1) % slides.length;
          slides[current].classList.add('hero-nominees__slide--active');
        });
      });

      /* ── Stack (column 3) vertical slider ── */
      var stacks = document.querySelectorAll('[data-stack-slider]');
      stacks.forEach(function (stack) {
        if (stack._stackInit) return;
        stack._stackInit = true;
        var track = stack.querySelector('[data-stack-track]');
        if (!track) return;
        var cards = track.querySelectorAll('.hero-nominees__stack-card');
        var total = cards.length;
        if (total < 2) return;
        var currentCard = 0;

        function updateTrack() {
          track.style.transform = 'translateY(-' + (currentCard * (100 / total)) + '%)';
        }

        stack.addEventListener('click', function (e) {
          var prev = e.target.closest('[data-stack-prev]');
          var next = e.target.closest('[data-stack-next]');
          if (prev) {
            e.preventDefault();
            currentCard = (currentCard - 1 + total) % total;
            updateTrack();
          } else if (next) {
            e.preventDefault();
            currentCard = (currentCard + 1) % total;
            updateTrack();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
